export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.10.16-1125.20",
  commitId: "230af5d6e8b4561bb6ee19074a7282cde9693d2f",
  commitTime: "2026-10-16T11:25:20.000Z",
});
